export default {
  namespaced: true,
  state: {
    selectedObs: {
      /** 管理事務所番号 */
      ofcCd: null,
      /** 観測所種別コード */
      itmkndCd: null,
      /** 観測所コード */
      obsCd: null,
    },
  },
  mutations: {
    /**
     * 管理事務所番号を設定
     * @param {*} state
     * @param ofcCd 管理事務所番号
     */
    setOfcCd(state, ofcCd) {
      state.selectedObs.ofcCd = ofcCd;
    },
    /**
     * 観測所種別コードを設定
     * @param {*} state
     * @param itmkndCd 観測所種別コード
     */
    setItmkndCd(state, itmkndCd) {
      state.selectedObs.itmkndCd = itmkndCd;
    },
    /**
     * 観測所コードを設定
     * @param {*} state
     * @param obsCd 観測所コード
     */
    setObsCd(state, obsCd) {
      state.selectedObs.obsCd = obsCd;
    },
  },
  actions: {},
};
